var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorderRadiusLeftBottom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 6.70833C3.35699 6.70833 3.37533 6.69 3.37533 6.66667C3.37533 6.64333 3.35699 6.625 3.33366 6.625C3.31033 6.625 3.29199 6.64333 3.29199 6.66667C3.29199 6.69 3.31033 6.70833 3.33366 6.70833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.292 16.6667C13.292 16.69 13.3103 16.7083 13.3337 16.7083C13.357 16.7083 13.3753 16.69 13.3753 16.6667C13.3753 16.6433 13.357 16.625 13.3337 16.625C13.3103 16.625 13.292 16.6433 13.292 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 3.37502C10.0235 3.37502 10.0418 3.35669 10.0418 3.33335C10.0418 3.31002 10.0235 3.29169 10.0002 3.29169C9.97683 3.29169 9.9585 3.31002 9.9585 3.33335C9.9585 3.35669 9.97683 3.37502 10.0002 3.37502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 3.33335C6.625 3.35669 6.64333 3.37502 6.66667 3.37502C6.69 3.37502 6.70833 3.35669 6.70833 3.33335C6.70833 3.31002 6.69 3.29169 6.66667 3.29169C6.64333 3.29169 6.625 3.31002 6.625 3.33335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.292 3.33335C13.292 3.35669 13.3103 3.37502 13.3337 3.37502C13.357 3.37502 13.3753 3.35669 13.3753 3.33335C13.3753 3.31002 13.357 3.29169 13.3337 3.29169C13.3103 3.29169 13.292 3.31002 13.292 3.33335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 3.37502C3.35699 3.37502 3.37533 3.35669 3.37533 3.33335C3.37533 3.31002 3.35699 3.29169 3.33366 3.29169C3.31033 3.29169 3.29199 3.31002 3.29199 3.33335C3.29199 3.35669 3.31033 3.37502 3.33366 3.37502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.95831C16.6433 9.95831 16.625 9.97665 16.625 9.99998C16.625 10.0233 16.6433 10.0416 16.6667 10.0416C16.69 10.0416 16.7083 10.0233 16.7083 9.99998C16.7083 9.97665 16.69 9.95831 16.6667 9.95831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.625C16.6433 6.625 16.625 6.64333 16.625 6.66667C16.625 6.69 16.6433 6.70833 16.6667 6.70833C16.69 6.70833 16.7083 6.69 16.7083 6.66667C16.7083 6.64333 16.69 6.625 16.6667 6.625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.2917C16.6433 13.2917 16.625 13.31 16.625 13.3334C16.625 13.3567 16.6433 13.375 16.6667 13.375C16.69 13.375 16.7083 13.3567 16.7083 13.3334C16.7083 13.31 16.69 13.2917 16.6667 13.2917",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.29169C16.6433 3.29169 16.625 3.31002 16.625 3.33335C16.625 3.35669 16.6433 3.37502 16.6667 3.37502C16.69 3.37502 16.7083 3.35669 16.7083 3.33335C16.7083 3.31002 16.69 3.29169 16.6667 3.29169",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.625C16.6433 16.625 16.625 16.6433 16.625 16.6667C16.625 16.69 16.6433 16.7083 16.6667 16.7083C16.69 16.7083 16.7083 16.69 16.7083 16.6667C16.7083 16.6433 16.69 16.625 16.6667 16.625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 11.8C2.97634 11.8 3.2002 12.0238 3.2002 12.3V16.8049H7.7002L7.80078 16.8146C8.0287 16.8612 8.2002 17.0632 8.2002 17.3049C8.19998 17.5463 8.02855 17.7476 7.80078 17.7941L7.7002 17.8049H2.7002C2.4242 17.8049 2.20044 17.5808 2.2002 17.3049C2.2002 17.2799 2.2035 17.2556 2.20703 17.2316C2.2035 17.2077 2.2002 17.1833 2.2002 17.1584V12.3C2.2002 12.0238 2.42405 11.8 2.7002 11.8Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorderRadiusLeftBottom);
export default ForwardRef;